function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 16C0 9.373 5.373 4 12 4h32c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12H12C5.373 60 0 54.627 0 48V16z",
  fill: "url(#catalog_svg__paint0_linear)"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#catalog_svg__filter0_b)",
  fillOpacity: 0.6
}, /*#__PURE__*/React.createElement("path", {
  d: "M16 18a4 4 0 108 0 4 4 0 00-8 0z",
  fill: "url(#catalog_svg__paint1_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 32a4 4 0 108 0 4 4 0 00-8 0z",
  fill: "url(#catalog_svg__paint2_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 50a4 4 0 110-8 4 4 0 010 8z",
  fill: "url(#catalog_svg__paint3_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32 14a4 4 0 000 8h28a4 4 0 000-8H32z",
  fill: "url(#catalog_svg__paint4_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28 32a4 4 0 014-4h28a4 4 0 010 8H32a4 4 0 01-4-4z",
  fill: "url(#catalog_svg__paint5_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32 42a4 4 0 000 8h28a4 4 0 000-8H32z",
  fill: "url(#catalog_svg__paint6_linear)"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "catalog_svg__paint0_linear",
  x1: 52.063,
  y1: 60,
  x2: 11.375,
  y2: 4,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#22A2FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#94D2FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "catalog_svg__paint1_linear",
  x1: 11.625,
  y1: 20.667,
  x2: 80.375,
  y2: 20.667,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E8F1FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#87B8FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "catalog_svg__paint2_linear",
  x1: 11.625,
  y1: 20.667,
  x2: 80.375,
  y2: 20.667,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E8F1FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#87B8FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "catalog_svg__paint3_linear",
  x1: 11.625,
  y1: 20.667,
  x2: 80.375,
  y2: 20.667,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E8F1FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#87B8FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "catalog_svg__paint4_linear",
  x1: 11.625,
  y1: 20.667,
  x2: 80.375,
  y2: 20.667,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E8F1FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#87B8FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "catalog_svg__paint5_linear",
  x1: 11.625,
  y1: 20.667,
  x2: 80.375,
  y2: 20.667,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E8F1FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#87B8FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "catalog_svg__paint6_linear",
  x1: 11.625,
  y1: 20.667,
  x2: 80.375,
  y2: 20.667,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E8F1FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#87B8FF"
})), /*#__PURE__*/React.createElement("filter", {
  id: "catalog_svg__filter0_b",
  x: 12,
  y: 10,
  width: 56,
  height: 44,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImage",
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur",
  result: "shape"
})));

function SvgCatalog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA2NCA2NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgMTZDMCA5LjM3MjU4IDUuMzcyNTggNCAxMiA0SDQ0QzUwLjYyNzQgNCA1NiA5LjM3MjU4IDU2IDE2VjQ4QzU2IDU0LjYyNzQgNTAuNjI3NCA2MCA0NCA2MEgxMkM1LjM3MjU4IDYwIDAgNTQuNjI3NCAwIDQ4VjE2WiIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyKSIvPgo8ZyBmaWx0ZXI9InVybCgjZmlsdGVyMF9iKSI+CjxwYXRoIGQ9Ik0xNiAxOEMxNiAyMC4yMDkxIDE3Ljc5MDkgMjIgMjAgMjJDMjIuMjA5MSAyMiAyNCAyMC4yMDkxIDI0IDE4QzI0IDE1Ljc5MDkgMjIuMjA5MSAxNCAyMCAxNEMxNy43OTA5IDE0IDE2IDE1Ljc5MDkgMTYgMThaIiBmaWxsPSJ1cmwoI3BhaW50MV9saW5lYXIpIiBmaWxsLW9wYWNpdHk9IjAuNiIvPgo8cGF0aCBkPSJNMTYgMzJDMTYgMzQuMjA5MSAxNy43OTA5IDM2IDIwIDM2QzIyLjIwOTEgMzYgMjQgMzQuMjA5MSAyNCAzMkMyNCAyOS43OTA5IDIyLjIwOTEgMjggMjAgMjhDMTcuNzkwOSAyOCAxNiAyOS43OTA5IDE2IDMyWiIgZmlsbD0idXJsKCNwYWludDJfbGluZWFyKSIgZmlsbC1vcGFjaXR5PSIwLjYiLz4KPHBhdGggZD0iTTIwIDUwQzE3Ljc5MDkgNTAgMTYgNDguMjA5MSAxNiA0NkMxNiA0My43OTA5IDE3Ljc5MDkgNDIgMjAgNDJDMjIuMjA5MSA0MiAyNCA0My43OTA5IDI0IDQ2QzI0IDQ4LjIwOTEgMjIuMjA5MSA1MCAyMCA1MFoiIGZpbGw9InVybCgjcGFpbnQzX2xpbmVhcikiIGZpbGwtb3BhY2l0eT0iMC42Ii8+CjxwYXRoIGQ9Ik0zMiAxNEMyOS43OTA5IDE0IDI4IDE1Ljc5MDkgMjggMThDMjggMjAuMjA5MSAyOS43OTA5IDIyIDMyIDIySDYwQzYyLjIwOTEgMjIgNjQgMjAuMjA5MSA2NCAxOEM2NCAxNS43OTA5IDYyLjIwOTEgMTQgNjAgMTRIMzJaIiBmaWxsPSJ1cmwoI3BhaW50NF9saW5lYXIpIiBmaWxsLW9wYWNpdHk9IjAuNiIvPgo8cGF0aCBkPSJNMjggMzJDMjggMjkuNzkwOSAyOS43OTA5IDI4IDMyIDI4SDYwQzYyLjIwOTEgMjggNjQgMjkuNzkwOSA2NCAzMkM2NCAzNC4yMDkxIDYyLjIwOTEgMzYgNjAgMzZIMzJDMjkuNzkwOSAzNiAyOCAzNC4yMDkxIDI4IDMyWiIgZmlsbD0idXJsKCNwYWludDVfbGluZWFyKSIgZmlsbC1vcGFjaXR5PSIwLjYiLz4KPHBhdGggZD0iTTMyIDQyQzI5Ljc5MDkgNDIgMjggNDMuNzkwOSAyOCA0NkMyOCA0OC4yMDkxIDI5Ljc5MDkgNTAgMzIgNTBINjBDNjIuMjA5MSA1MCA2NCA0OC4yMDkxIDY0IDQ2QzY0IDQzLjc5MDkgNjIuMjA5MSA0MiA2MCA0MkgzMloiIGZpbGw9InVybCgjcGFpbnQ2X2xpbmVhcikiIGZpbGwtb3BhY2l0eT0iMC42Ii8+CjwvZz4KPGRlZnM+CjxmaWx0ZXIgaWQ9ImZpbHRlcjBfYiIgeD0iMTIiIHk9IjEwIiB3aWR0aD0iNTYiIGhlaWdodD0iNDQiIGZpbHRlclVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgY29sb3ItaW50ZXJwb2xhdGlvbi1maWx0ZXJzPSJzUkdCIj4KPGZlRmxvb2QgZmxvb2Qtb3BhY2l0eT0iMCIgcmVzdWx0PSJCYWNrZ3JvdW5kSW1hZ2VGaXgiLz4KPGZlR2F1c3NpYW5CbHVyIGluPSJCYWNrZ3JvdW5kSW1hZ2UiIHN0ZERldmlhdGlvbj0iMiIvPgo8ZmVDb21wb3NpdGUgaW4yPSJTb3VyY2VBbHBoYSIgb3BlcmF0b3I9ImluIiByZXN1bHQ9ImVmZmVjdDFfYmFja2dyb3VuZEJsdXIiLz4KPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbj0iU291cmNlR3JhcGhpYyIgaW4yPSJlZmZlY3QxX2JhY2tncm91bmRCbHVyIiByZXN1bHQ9InNoYXBlIi8+CjwvZmlsdGVyPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXIiIHgxPSI1Mi4wNjI1IiB5MT0iNjAiIHgyPSIxMS4zNzUiIHkyPSI0IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiMyMkEyRkYiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjOTREMkZGIi8+CjwvbGluZWFyR3JhZGllbnQ+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQxX2xpbmVhciIgeDE9IjExLjYyNSIgeTE9IjIwLjY2NjciIHgyPSI4MC4zNzUiIHkyPSIyMC42NjY3IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiNFOEYxRkYiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjODdCOEZGIi8+CjwvbGluZWFyR3JhZGllbnQ+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQyX2xpbmVhciIgeDE9IjExLjYyNSIgeTE9IjIwLjY2NjciIHgyPSI4MC4zNzUiIHkyPSIyMC42NjY3IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiNFOEYxRkYiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjODdCOEZGIi8+CjwvbGluZWFyR3JhZGllbnQ+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQzX2xpbmVhciIgeDE9IjExLjYyNSIgeTE9IjIwLjY2NjciIHgyPSI4MC4zNzUiIHkyPSIyMC42NjY3IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiNFOEYxRkYiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjODdCOEZGIi8+CjwvbGluZWFyR3JhZGllbnQ+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQ0X2xpbmVhciIgeDE9IjExLjYyNSIgeTE9IjIwLjY2NjciIHgyPSI4MC4zNzUiIHkyPSIyMC42NjY3IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiNFOEYxRkYiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjODdCOEZGIi8+CjwvbGluZWFyR3JhZGllbnQ+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQ1X2xpbmVhciIgeDE9IjExLjYyNSIgeTE9IjIwLjY2NjciIHgyPSI4MC4zNzUiIHkyPSIyMC42NjY3IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiNFOEYxRkYiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjODdCOEZGIi8+CjwvbGluZWFyR3JhZGllbnQ+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQ2X2xpbmVhciIgeDE9IjExLjYyNSIgeTE9IjIwLjY2NjciIHgyPSI4MC4zNzUiIHkyPSIyMC42NjY3IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiNFOEYxRkYiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjODdCOEZGIi8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg==";
export { SvgCatalog as ReactComponent };